import { History } from "lucide-react";

const describe = (e) => {
  const d = e.details || {};
  if (e.action === "comp") return `Granted comp ${d.until ? `until ${d.until}` : "(permanent)"}`;
  if (e.action === "uncomp") return `Removed comp → ${d.new_status}`;
  if (e.action === "extend_trial") return `Extended trial by ${d.days} days`;
  if (e.action === "note_add") return `Added note: "${d.excerpt}"`;
  if (e.action === "note_delete") return `Deleted note: "${d.excerpt}"`;
  if (e.action === "preview_limit") return `Preview limit ${d.from ?? "default"} → ${d.to ?? "default"}`;
  return e.action.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
};

export const AuditList = ({ items }) => (
  <section className="rounded-2xl border bg-card p-5 shadow-soft" data-testid="admin-audit-list">
    <h2 className="flex items-center gap-2 text-base font-semibold text-foreground"><History className="h-4 w-4" />Admin history</h2>
    {items.length === 0 ? <p className="mt-2 text-sm text-muted-foreground">No admin actions yet.</p> : (
      <ul className="mt-3 divide-y">
        {items.map((e, i) => (
          <li key={i} className="flex flex-col gap-0.5 py-2.5 text-sm sm:flex-row sm:items-center sm:justify-between" data-testid="admin-audit-entry">
            <span className="font-medium text-foreground">{describe(e)}</span>
            <span className="text-xs text-muted-foreground">{e.admin_email} · {new Date(e.created_at).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" })}</span>
          </li>
        ))}
      </ul>
    )}
  </section>
);
